import React from 'react'
import ProdIOOOutViewRow from './ProdIOOOutViewRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOOutView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value="Output History" /></span>
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable uiProductionTable uiRawDataView" style={{ minWidth: "870px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Output" /></li>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Date" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOOutViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOOutView, "prodIOOOUT", "");
